{
  "title": "如何計算、鎖定並公布結果",
  "description": "依輪次與組別計算成績，人工覆核後鎖定並公布。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，結果即公布，參賽者可查看成績與名次；公布後不可再變更。",
  "roleNote": "競賽管理員",
  "prerequisites": ["該輪次已有評審完成評分", "已確認評分規準版本正確"],
  "pathLabel": "主辦方後台 → 我的競賽 → 結果",
  "steps": [
    {
      "title": "1. 計算結果",
      "description": "選擇輪次與（可選）組別，點選「計算結果」；系統會先顯示風險警示文字（說明只會納入至少 2 位評審完成鎖定評分的作品，未達門檻者將列為「缺少有效評分」），需再次點選「確認計算」才會真正建立這次的結果紀錄。單一作品須至少有 2 位評審的有效鎖定分數才會被計入排名，未達門檻的作品會被列為排除項目，不是計算失敗。若評審在分數鎖定後才被登記利益衝突，該筆分數計算時一律追溯排除。"
    },
    {
      "title": "2. 人工覆核",
      "description": "計算完成後結果狀態為「已計算」，卡片上會完整呈現這次計算的中繼資料（Run ID、計算時間、計算者、已納入評分數、缺少有效評分數與隊伍名稱、並列訊號），可先核對這些數字再決定是否覆核個別作品的獎項等第（附理由），建議在鎖定前完成所有覆核。"
    },
    {
      "title": "3. 鎖定結果",
      "description": "覆核完成後點選「鎖定」，系統會先顯示影響說明文字（鎖定後仍可調整獎項等第（須附理由），直到公布為止，公布後才不可變更；鎖定不影響其他結果紀錄、紀錄本身也不會被刪除），需再次點選確認才會真正鎖定，狀態轉為「已鎖定」，卡片會多顯示「鎖定者」。鎖定與公布是各自獨立、各自有稽核紀錄的操作，鎖定不等於已公布。"
    },
    {
      "title": "4. 公布結果",
      "description": "確認無誤後點選「公布」；只有已鎖定的結果才能公布，公布是與鎖定分開的獨立按鈕。公布後狀態轉為「已公布」，卡片會多顯示「發布者」，該次結果即不可再變更，如需修正須計算新的一次結果。"
    }
  ],
  "afterward": [
    "結果狀態顯示「已公布」",
    "參賽者可在自己的競賽頁面查看相關成績與名次",
    "公布前的所有調整都已定案，無法再修改"
  ],
  "nextSteps": "公布後若發現需要修正，需重新計算一次新的結果（附理由），而非修改已公布的舊結果。",
  "faq": [
    {
      "q": "計算結果後，有些作品不見了、沒有名次？",
      "a": "這是預期行為，不是錯誤。單一作品須至少有 2 位評審的有效鎖定分數才會被計入該次結果；只有 1 位（或 0 位）評審完成，或原本 2 位評審中有一位因利益衝突被排除，該作品就不會出現在排名裡。請到「評審設定」確認該作品的評審指派與完成進度，補齊後重新計算結果即可。"
    },
    {
      "q": "已公布的結果還能修改嗎？",
      "a": "不行。已公布的結果不可再變更；若真的需要修正，需另外計算一次新的結果，不建議直接更動已公布資料。"
    },
    {
      "q": "鎖定後還能調整獎項等第嗎？",
      "a": "可以。只要結果尚未公布（狀態為「已計算」或「已鎖定」），皆可針對個別作品調整獎項等第並附理由；一旦公布即無法再調整。"
    }
  ]
}
